export default "/app/themes/majeures/build/images/logo_white.svg?b75e49cd6e5a66643fab759e48f02f81";